import "./FiguresBlock.scss";
import {
  BlockTop,
  GridPresetOneThird,
  GridPresetWideContent,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";
import { FiguresBlockProps } from "/Models/Generated/FiguresBlockProps";
import { FiguresItemBlockProps } from "/Models/Generated/FiguresItemBlockProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import FiguresItemBlock from "../FiguresItemBlock/FiguresItemBlock";

const FiguresBlock = ({
  blockTop,
  theme,
  figure1,
  figure1PropertyName,
  figure2,
  figure2PropertyName,
  figure3,
  figure3PropertyName,
}: FiguresBlockProps) => {
  const bem = createSpreadableBem("figures-block-norad");
  return (
    <div
      {...bem("", {
        "--primary": theme === NoradTheme.Primary,
        "--secondary": theme === NoradTheme.Secondary,
        "--ternary": theme === NoradTheme.Ternary,
      })}
    >
      <GridRow>
        {blockTop && (
          <GridPresetWideContent>
            <div {...bem("__block-top-wrapper")}>
              <BlockTop
                {...blockTop}
                theme={theme === NoradTheme.Ternary ? "secondary" : "primary"}
              />
            </div>
          </GridPresetWideContent>
        )}
        <RenderFigure
          bem={bem}
          figure={figure1}
          figurePropertyName={figure1PropertyName}
          lastItem={false}
          theme={theme}
        />
        <RenderFigure
          bem={bem}
          figure={figure2}
          figurePropertyName={figure2PropertyName}
          lastItem={false}
          theme={theme}
        />
        <RenderFigure
          bem={bem}
          figure={figure3}
          figurePropertyName={figure3PropertyName}
          lastItem={true}
          theme={theme}
        />
      </GridRow>
    </div>
  );
};

interface RenderFigureProps {
  bem: ReturnType<typeof createSpreadableBem>;
  figure?: FiguresItemBlockProps;
  figurePropertyName?: string;
  lastItem?: boolean;
  theme?: NoradTheme;
}

const RenderFigure = ({
  bem,
  figure,
  figurePropertyName,
  lastItem,
  theme,
}: RenderFigureProps) => (
  <GridPresetOneThird>
    <div {...bem("__item-container")}>
      <OptimizelyEditProperty propertyName={figurePropertyName} clientRender>
        {figure && (
          <div
            {...bem("__item-wrapper", {
              "--last": lastItem,
            })}
          >
            <FiguresItemBlock {...figure} theme={theme} lastItem={lastItem} />
          </div>
        )}
      </OptimizelyEditProperty>
    </div>
  </GridPresetOneThird>
);

export default FiguresBlock;
